<template>
  <div>
    <div>
      <v-form>
        <v-card flat class="pa-4 mb-4">
          <v-card-title>Reporte Z</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <label>Fecha inicial</label>
                <div style="border-bottom: 1px solid; margin-bottom: -1px">
                  <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                    @selected="selectDate" :value="input_date.format('MM/DD/YYYY')">
                  </Datepicker>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Fecha inicial</label>
                <div style="border-bottom: 1px solid; margin-bottom: -1px">
                  <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                    @selected="selectDateFinal" :disabled-dates="disableDates"
                    :value="input_date_final.format('MM/DD/YYYY')"></Datepicker>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <v-autocomplete label="Departamentos" v-model="selectDep" item-text="Nombre" item-value="id"
                  :items="departamentos"></v-autocomplete>
              </v-col>
              <v-col cols="12" md="12">
                <v-btn block :loading="loadingpdf" color="green" class="mt-4" dark @click="generatePdf()">
                  Generar reporte
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </div>
  </div>
</template>

<script>
import "../../assets/css/sideBar.css";
import Datepicker from "vuejs-datepicker";
import Currency from "../../clases/Currencies.js";
import moment from "moment";
import { mapGetters } from "vuex";
import Modificadores from "../../clases/Modificadores.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteZ from "../../clases/PdfMakers/Contabilidad/ReporteZContabilidad.js";
import { forEach } from "lodash";

export default {
  name: "ReporteTransacciones",
  components: {
    Datepicker,
  },
  props: ["hideMenu"],
  data() {
    return {
      metodosPagoSelected: [],
      Comensales: 0,
      loadingpdf: false,
      showDevs: true,
      selectTurno: "ALL",
      selectCaja: "",
      aperturas: [],
      cierresList: [],
      pagos: [],
      monedas: [],
      transaccion: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      cajero: "ALL",
      data_cajas: [],
      showModal: false,
      formKey: 0,
      data_ventas: [],
      data_devoluciones: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      Categories: [],
      familias: [],
      selectDep: "ALL",
      cajeros: [{ id: "ALL", Nomb: "Todos" }],
      reservations: [],
      cantFilter: "",
      countsData: [],
      datos: {
        ventas: [],
        descuentos: [],
      },
    };
  },
  computed: {
    ...mapGetters(["getFirebaseApp"]),
    ...mapGetters(["getClientes", "getPDVPagosTipos", "getPDVMonedasLista"]),
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },


    ventas_comp() {
      this.data_ventas.forEach((venta) => {
        if (venta.Cantidad == this.cantFilter) {
          venta.match = true;
        } else {
          venta.match = false;
        }
        for (const property in venta.Catalogo) {
          if (venta.Catalogo[property].Modificadores) {
            venta.Catalogo[property].ModificadoresList =
              Modificadores.parseToListOption(
                venta.Catalogo[property].Modificadores
              );
            let totalModi = 0;
            venta.Catalogo[property].ModificadoresList.forEach((modi) => {
              totalModi += modi.pco.C;
            });
            venta.Catalogo[property].totalModi = totalModi;
          }
        }
      });
      let data = this.data_ventas;
      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
    devoluciones_comp() {
      let data = this.data_devoluciones;

      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_clients() {
      let clientes = [];
      this.getClientes.forEach((cli) => {
        clientes.push({ id: cli.id, text: cli.Apellidos + " " + cli.Nombres });
      });
      return clientes;
    },
    comp_filter() {
      let filter = [];

      this.pagos.forEach((pago) => {
        this.monedas.forEach((moneda) => {
          filter.push(pago + "_" + moneda);
        });
      });
      return filter;
    },
  },
  methods: {

    async generatePdf() {
      this.loadingpdf = true;
      await this.getVentas();

      this.loadingpdf = false;
      let zReport = new ReporteZ();
      let tenant = this.$store.getters.getFirebaseApp.tenant;
      let Cajero = "Todos"
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        Turno: "TODOS",
        Tenant: tenant,
        TITLE:
          tenant == "PCUN"
            ? "CLUBS PUERTO CANCUN SA DE CV"
            : tenant == "BOKA"
              ? "BOKKA SMOKEHOUSE & GRILL"
              : "REPORTE Z",
        Departamento: this.selectDep,
        Comensales: this.Comensales,
        DeptoName: this.$pgsHelper.getById(
          this.departamentos,
          "id",
          this.selectDep
        ).Nombre,
        Cajero: Cajero,
        Caja: "Todas",
      };
      //log(this.countsData)
      let docData = zReport.getDocData(
        this.$pgsHelper.cloneObj(this.countsData),
        this.$pgsHelper.cloneObj(this.datos.ventas),
        mainData,
      );
      pdfmake.createPdf(docData).open();
    },
    countsProcess(data) {
      let dataTotalsSystem = {};
      let dataPropinas = {}
      data.forEach((venta) => {
        venta.Pagos.forEach((pago) => {
          if (pago.tp == "VISA_MXN" || pago.tp == "MACA_MXN") {
            if (!dataTotalsSystem["VISA/MACA_MXN"]) {
              dataTotalsSystem["VISA/MACA_MXN"] = 0
            }
            dataTotalsSystem["VISA/MACA_MXN"] += pago.rl.C
          } else {
            if (!dataTotalsSystem[pago.tp]) {
              dataTotalsSystem[pago.tp] = 0
            }
            dataTotalsSystem[pago.tp] += pago.rl.C
            if (pago.rl.C == "USD") {
              if (!dataTotalsSystem[pago.tp + "_CONV"]) {
                dataTotalsSystem[pago.tp + "_CONV"] = 0
              }
              dataTotalsSystem[pago.tp + "_CONV"] += pago.df.C
            }
          }

        })
        if (venta.Cambio) {
          if (!dataTotalsSystem["EFVO_MXN"]) {
            dataTotalsSystem["EFVO_MXN"] = 0
          }
          //console.log(venta.Cambio[Currency.getCurrencyDefault()])
          dataTotalsSystem["EFVO_MXN"] = Number(dataTotalsSystem["EFVO_MXN"] - venta.Cambio[Currency.getCurrencyDefault()]);
        }

        if(venta.Props){
          venta.Props.forEach((prop) => {
            if (prop.tp == "VISA_MXN" || prop.tp == "MACA_MXN") {
            if (!dataPropinas["VISA/MACA_MXN"]) {
              dataPropinas["VISA/MACA_MXN"] = 0
            }
            dataPropinas["VISA/MACA_MXN"] += prop.rl.C
          } else {
            if (!dataPropinas[prop.tp]) {
              dataPropinas[prop.tp] = 0
            }
            dataPropinas[prop.tp] += prop.rl.C
            if (prop.rl.C == "USD") {
              if (!dataPropinas[prop.tp + "_CONV"]) {
                dataPropinas[prop.tp + "_CONV"] = 0
              }
              dataPropinas[prop.tp + "_CONV"] += prop.df.C
            }
          }
          })
        }

      })


      return {
        dataTotalsSystem: dataTotalsSystem,
        dataPropinas:dataPropinas,
        
      };
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("HH:mm");
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      let listVentas = []
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Turno.fe", ">=", startDate),
        firestore.where("Turno.fe", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      if (this.selectDep != "ALL") {
        filter.push(firestore.where("Departamento.id", "==", this.selectDep));
      }


      const data = await firestore.queryBuilder("PDV_Ventas", filter);
      let preData = [];
      preData = data.docs.map((doc) => {
        listVentas.push({ id: doc.ref.id, ...doc.data() });

      });
      /*listVentas.forEach((venta)=>{
        let totalPago = 0
        let totalVenta = 0
        venta.Pagos.forEach((p)=>{
          totalPago += p.rl.C
        })
        venta.Catalogo.forEach((prod) => {
          totalVenta += (prod.sb.C + prod.iv.C)
        })
        console.log(totalPago,totalVenta,venta.Folio)
      })*/
      this.datos.ventas = this.processVentas(listVentas);
      let dataProcessed = await this.countsProcess(listVentas)
      this.countsData = dataProcessed;
    },
    processVentas(datos) {
      console.time("ProcessVentas");
      this.Comensales = 0;
      let productosVenta = [];
      let descuentosGeneral = [];
      datos.forEach((el) => {
        //console.log("procesado", el)
        this.Comensales += el.Comensales ? el.Comensales : 1;
        el.Catalogo.forEach((prod) => {
          if (prod.Id.includes("RVA-ExtraRidder")) {
            prod.Familia.I = "EXTRA RIDER";
            prod.Familia.N = "EXTRA RIDER";
            prod.Iva = 0;
          }
          if (prod.Id.includes("Reserva")) {
            if (prod.Orn != "Golf") {
              prod.Familia.I = prod.Orn;
              prod.Familia.N = prod.Orn;
            } else {
              prod.Familia.I = "GREEN FEE";
              prod.Familia.N = "GREEN FEE";
            }
          }
          if (prod.Tip == "ACT-Reserva") {
            let categoria = this.$pgsHelper.getById(
              this.Categories,
              "id",
              prod.Categoria.I
            );
            if (categoria) {
              let familiaData = this.$pgsHelper.getById(
                this.familias,
                "id",
                categoria.Familia
              );
              if (familiaData) {
                prod.Familia.I = categoria.Familia;
                prod.Familia.N = familiaData.Nombre;
              }
            }
          }
          if (prod.Id.includes("RVA-Transportacion")) {
            prod.Familia.I = "TRANSPORTACION";
            prod.Familia.N = "TRANSPORTACION";
            prod.Iva = 0;
          }
          if (prod.Tip == "Cupon") {
            prod.Familia.N = "Paquetes Rondas de Golf";
            prod.Familia.I = "Paquetes Rondas de Golf";
            prod.Iva = 0;
          }
          if (prod.Catalogo) {
            if (prod.Catalogo[0]) {
              let Catalogo = prod.Catalogo[0];
              if (Catalogo.Tip == "Serie") {
                prod.Familia.I = "GREEN FEE";
                prod.Familia.N = "GREEN FEE";
              }
            }
          }

          try {
            let noGrava = false;
            if (
              prod.Nombre.includes("Nueva Membresia") ||
              prod.Nombre.includes("Cuota Extraordinaria")
            ) {
              noGrava = true;
            }
            let producto = {
              ClaveSAT: prod.Familia ? prod.Familia.C : "-",
              Familia: prod.Familia ? prod.Familia.N : "-",
              FamiliaId: prod.Familia.I,
              Cantidad: prod.Cnt,
              prod: prod,
              iva: !noGrava ? prod.Iva : 0,
              Descuento: "-",
              Subtotal: prod.sb.C,
              Impuestos: prod.iv.C,
            };
            productosVenta.push(producto);


          } catch (e) {
            console.log(el.Folio);
          }
        });
      });
      console.timeEnd("ProcessVentas");

      this.datos.descuentos = descuentosGeneral;
      return this.groupByFamilia(productosVenta);
    },
    groupByFamilia(productos) {
      let groupData = {};
      //.log(productos)
      productos.forEach((prod) => {
        //console.log(prod)
        if (groupData[prod.FamiliaId]) {
          groupData[prod.FamiliaId].Cantidad =
            Number(groupData[prod.FamiliaId].Cantidad) + Number(prod.Cantidad);
          groupData[prod.FamiliaId].Subtotal =
            Number(groupData[prod.FamiliaId].Subtotal) + Number(prod.Subtotal);
          groupData[prod.FamiliaId].Impuestos =
            Number(groupData[prod.FamiliaId].Impuestos) +
            Number(prod.Impuestos);
        } else {
          groupData[prod.FamiliaId] = {
            Cantidad: Number(prod.Cantidad),
            Subtotal: Number(prod.Subtotal),
            Impuestos: Number(prod.Impuestos),
            Iva: Number(prod.iva),
            Nombre: prod.Familia,
          };
        }
      });

      return groupData;
    },
  },
  mounted() {
  },
  beforeCreate: function () { },
  beforeMount: function () {
    this.$emit("useNav", true);
  },
};
</script>

<style scoped>
.activeClass {
  background: #2185d075 !important;
}
</style>
